import { withNamespace } from "@/i18n/lazy-route"

/** Bank transfers as staff review them (LLD §9.19, Task 6.3), with the `adminTransfers` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/adminTransfers.json"),
  fr: () => import("@/i18n/locales/fr/adminTransfers.json"),
}

export const TransfersScreen = withNamespace(
  "adminTransfers",
  () => import("./screens/TransfersScreen"),
  translations,
)
export const TransferDetailScreen = withNamespace(
  "adminTransfers",
  () => import("./screens/TransferDetailScreen"),
  translations,
)
